import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";

export default function SharedRegionProviderOverlay({ region, provider, setRegion, setProvider, chat_id, close }) {

    const [regionSearchValue, setRegionSearchValue] = useState("");
    const [availableRegions, setAvailableRegions] = useState([
        { "value": "", "label": "Не установлен" },
        { "value": "Москва", "label": "Москва" },
        { "value": "Санкт-Петербург", "label": "Санкт-Петербург" },
        { "value": "Адыгея", "label": "Адыгея" },
        { "value": "Алтай", "label": "Алтай" },
        { "value": "Алтайский край", "label": "Алтайский край" },
        { "value": "Амурская область", "label": "Амурская область" },
        { "value": "Архангельская область", "label": "Архангельская область" },
        { "value": "Астраханская область", "label": "Астраханская область" },
        { "value": "Башкортостан", "label": "Башкортостан" },
        { "value": "Белгородская область", "label": "Белгородская область" },
        { "value": "Брянская область", "label": "Брянская область" },
        { "value": "Бурятия", "label": "Бурятия" },
        { "value": "Владимирская область", "label": "Владимирская область" },
        { "value": "Волгоградская область", "label": "Волгоградская область" },
        { "value": "Вологодская область", "label": "Вологодская область" },
        { "value": "Воронежская область", "label": "Воронежская область" },
        { "value": "Дагестан", "label": "Дагестан" },
        { "value": "Донецкая область", "label": "Донецкая область" },
        { "value": "Еврейская автономная область", "label": "Еврейская автономная область" },
        { "value": "Забайкальский край", "label": "Забайкальский край" },
        { "value": "Запорожская область", "label": "Запорожская область" },
        { "value": "Ивановская область", "label": "Ивановская область" },
        { "value": "Ингушетия", "label": "Ингушетия" },
        { "value": "Иркутская область", "label": "Иркутская область" },
        { "value": "Кабардино-Балкария", "label": "Кабардино-Балкария" },
        { "value": "Калининградская область", "label": "Калининградская область" },
        { "value": "Калмыкия", "label": "Калмыкия" },
        { "value": "Калужская область", "label": "Калужская область" },
        { "value": "Камчатский край", "label": "Камчатский край" },
        { "value": "Карачаево-Черкесия", "label": "Карачаево-Черкесия" },
        { "value": "Карелия", "label": "Карелия" },
        { "value": "Кемеровская область", "label": "Кемеровская область" },
        { "value": "Кировская область", "label": "Кировская область" },
        { "value": "Коми", "label": "Коми" },
        { "value": "Костромская область", "label": "Костромская область" },
        { "value": "Краснодарский край", "label": "Краснодарский край" },
        { "value": "Красноярский край", "label": "Красноярский край" },
        { "value": "Крым", "label": "Крым" },
        { "value": "Курганская область", "label": "Курганская область" },
        { "value": "Курская область", "label": "Курская область" },
        { "value": "Ленинградская область", "label": "Ленинградская область" },
        { "value": "Липецкая область", "label": "Липецкая область" },
        { "value": "Луганская область", "label": "Луганская область" },
        { "value": "Магаданская область", "label": "Магаданская область" },
        { "value": "Марий Эл", "label": "Марий Эл" },
        { "value": "Мордовия", "label": "Мордовия" },
        { "value": "Московская область", "label": "Московская область" },
        { "value": "Мурманская область", "label": "Мурманская область" },
        { "value": "Ненецкий автономный округ", "label": "Ненецкий автономный округ" },
        { "value": "Нижегородская область", "label": "Нижегородская область" },
        { "value": "Новгородская область", "label": "Новгородская область" },
        { "value": "Новосибирская область", "label": "Новосибирская область" },
        { "value": "Омская область", "label": "Омская область" },
        { "value": "Оренбургская область", "label": "Оренбургская область" },
        { "value": "Орловская область", "label": "Орловская область" },
        { "value": "Пензенская область", "label": "Пензенская область" },
        { "value": "Пермский край", "label": "Пермский край" },
        { "value": "Приморский край", "label": "Приморский край" },
        { "value": "Псковская область", "label": "Псковская область" },
        { "value": "Ростовская область", "label": "Ростовская область" },
        { "value": "Рязанская область", "label": "Рязанская область" },
        { "value": "Самарская область", "label": "Самарская область" },
        { "value": "Саратовская область", "label": "Саратовская область" },
        { "value": "Саха (Якутия)", "label": "Саха (Якутия)" },
        { "value": "Сахалинская область", "label": "Сахалинская область" },
        { "value": "Свердловская область", "label": "Свердловская область" },
        { "value": "Севастополь", "label": "Севастополь" },
        { "value": "Северная Осетия - Алания", "label": "Северная Осетия - Алания" },
        { "value": "Смоленская область", "label": "Смоленская область" },
        { "value": "Ставропольский край", "label": "Ставропольский край" },
        { "value": "Тамбовская область", "label": "Тамбовская область" },
        { "value": "Татарстан", "label": "Татарстан" },
        { "value": "Тверская область", "label": "Тверская область" },
        { "value": "Томская область", "label": "Томская область" },
        { "value": "Тульская область", "label": "Тульская область" },
        { "value": "Тыва", "label": "Тыва" },
        { "value": "Тюменская область", "label": "Тюменская область" },
        { "value": "Удмуртия", "label": "Удмуртия" },
        { "value": "Ульяновская область", "label": "Ульяновская область" },
        { "value": "Хабаровский край", "label": "Хабаровский край" },
        { "value": "Хакасия", "label": "Хакасия" },
        { "value": "Ханты-Мансийский автономный округ - Югра", "label": "Ханты-Мансийский АО - Югра" },
        { "value": "Херсонская область", "label": "Херсонская область" },
        { "value": "Челябинская область", "label": "Челябинская область" },
        { "value": "Чечня", "label": "Чечня" },
        { "value": "Чувашия", "label": "Чувашия" },
        { "value": "Чукотский автономный округ", "label": "Чукотский АО" },
        { "value": "Ямало-Ненецкий автономный округ", "label": "Ямало-Ненецкий АО" },
        { "value": "Ярославская область", "label": "Ярославская область" }
    ]
    )

    const saveRequest = async () => {
        const requestURL = `https://ger.wa.48.defaultbot.com/v4/update-user-provider-region`;
        const data = {
            region: region, provider: provider, chat_id: chat_id
        }

        const req = await axios.post(requestURL, data);
        console.log({ req })
        if (req.data.ok) {
            close()
        }
    }

    useEffect(() => {
        if (regionSearchValue !== '') {
            const filteredRegions = availableRegions.filter((region) => region.label.includes(regionSearchValue))
            if (filteredRegions.length > 0) {
                setRegion(filteredRegions[0].value)
            }
        }
    }, [regionSearchValue])

    return <div className='overlay'>
        <div className='overlay-content'>
            <div>Установить оператор / регион</div>
            <input className="t-input" placeholder="Search Region" value={regionSearchValue} onChange={e => setRegionSearchValue(e.target.value)} />
            <select className="t-input" value={region} onChange={e => setRegion(e.target.value)}>
                {availableRegions.filter((region) => region.label.includes(regionSearchValue)).map((region) => {
                    return <option value={region.value}>{region.label}</option>
                })}
            </select>
            <select className="t-input" value={provider} onChange={e => setProvider(e.target.value)}>
                <option value="">Не установлен</option>
                <optgroup label="Большие операторы">
                    <option value="МТС">МТС</option>
                    <option value="Теле2">Теле2</option>
                    <option value="Билайн">Билайн</option>
                    <option value="Т-Мобайл">Т-Мобайл</option>
                    <option value="СберМобайл">СберМобайл</option>
                    <option value="Yota">Yota</option>
                    <option value="Мегафон">Мегафон</option>
                </optgroup>
                <optgroup label="Провайдеры">
                    <option value="Дом.ру">Дом.ру</option>
                    <option value="Ростелеком">Ростелеком</option>
                </optgroup>
                <optgroup label="Региональные операторы">
                    <option value="Мотив">Мотив</option>
                    <option value="Феникс">Феникс</option>
                    <option value="Таттелеком">Таттелеком</option>
                    <option value="МКС">МКС</option>
                    <option value="К-Телеком">К-Телеком (Win)</option>
                    <option value="Миранда">Миранда</option>
                    <option value="Вайнах Телеком">Вайнах Телеком</option>
                    <option value="КТК-Телеком">КТК-Телеком (Волна)</option>
                    <option value="Уфанет">Уфанет</option>
                    <option value="Летай">Летай</option>
                </optgroup>
            </select>
            <button className='t-button' onClick={() => saveRequest()}>Сохранить</button>
        </div>
    </div>
}